var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://www.minderoo.org","target":"_blank","rel":"noopener"}},[_vm._v("Minderoo Foundation")])}
var staticRenderFns = []

export { render, staticRenderFns }